export const ContractNotificationEmailHTML = (data = {}) => {
  const {
    contractUniqueID = '—',
    contractTitle = '—',
    createdAt = '—',
    siteAssessmentRef = '—',
    fellingLicenceNo = '—',
    pricingVersion = '—',
    isAddendum = false,
    supplierName = '—',
    landownerName = '—',
    address = '—',
    county = '—',
    totalArea = '—',
    supplierType = '—',
    harvestedBy = '—',
    confirmedBy = '—',
    notificationContact = {},
    contractDetails = {},
    certificationInfo = null,
    productPricing = [],
    accountDetails = {},
    uploadedDocuments = [],
    contractUrl = '',
  } = data;

  const {
    contractType = '—',
    purchaseType = '—',
    startDate = '—',
    finishDate = '—',
    vatRate = '—',
    labelOfContract = '—',
  } = contractDetails;

  const tagYes = `<span class="tag-yes">Yes</span>`;
  const tagNo = `<span class="tag-no">No</span>`;
  const tag = v => (v === 'Yes' || v === true ? tagYes : tagNo);
  const fmt = v => (v != null && !isNaN(v) && v !== '—' ? `€ ${Number(v).toFixed(2)}` : '—');

  // Product pricing rows
  const pricingRows =
    productPricing.length === 0
      ? `<tr><td colspan="6" style="text-align:center;color:#999;">No pricing data</td></tr>`
      : productPricing
          .map(item => {
            const c = item.changed || {};
            const rowClass = item.isNew ? ' class="new-row"' : '';
            return `
        <tr${rowClass}>
          <td class="left"><strong>${item.product || '—'}</strong>${
              item.isNew ? ' <span class="tag-new">NEW</span>' : ''
            }</td>
          <td${c.destination ? ' class="changed"' : ''}>${item.destination || '—'}</td>
          <td${c.haulageRate ? ' class="changed"' : ''}>${fmt(item.haulageRate)}</td>
          <td${c.harvestingRate ? ' class="changed"' : ''}>${fmt(item.harvestingRate)}</td>
          <td${c.extractionRate ? ' class="changed"' : ''}>${fmt(item.extractionRate)}</td>
          <td${c.purchasePrice ? ' class="changed"' : ''}><strong>${fmt(item.purchasePrice)}</strong></td>
        </tr>`;
          })
          .join('');

  // Certification block — only rendered if sustainable
  const certSection = certificationInfo
    ? `
  <div class="divider"></div>
  <div class="section">
    <div class="section-title">Certification Information</div>
    <table class="data">
      <thead>
        <tr>
          <th>County</th>
          <th>Supplier Type</th>
          <th>Self Declaration</th>
          <th>Biomass Site</th>
          <th>Forest Grower</th>
          <th>Contract With</th>
          <th>Harvested By</th>
          <th>Tripartite Agmt</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>${certificationInfo.county || '—'}</td>
          <td>${certificationInfo.supplierType || '—'}</td>
          <td>${tag(certificationInfo.validSelfDeclaration)}</td>
          <td>${tag(certificationInfo.biomassSite)}</td>
          <td>${certificationInfo.forestGrower || '—'}</td>
          <td>${certificationInfo.contractWith || '—'}</td>
          <td>${certificationInfo.harvestedBy || '—'}</td>
          <td>${tag(certificationInfo.tripartiteAgreement)}</td>
        </tr>
      </tbody>
    </table>
    ${
      certificationInfo.notes
        ? `<p style="margin-top:8px;font-size:12px;color:#555;">Notes: ${certificationInfo.notes}</p>`
        : ''
    }
    ${
      certificationInfo.coillteRoadsideRate
        ? `
    <table class="kv" style="margin-top:10px;">
      <tr><td>Coillte Roadside Rate</td><td>${certificationInfo.coillteRoadsideRate}</td></tr>
      <tr><td>Short Stakes Premium</td><td>${certificationInfo.shortStakesPremium || '—'}</td></tr>
      <tr><td>Confirmed By</td><td>${certificationInfo.coillteRateConfirmedBy || '—'}</td></tr>
    </table>`
        : ''
    }
  </div>`
    : '';

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>${isAddendum ? 'Contract Addendum' : 'New Contract'} – ${contractUniqueID}</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body {
    background: #e8edf2;
    font-family: 'Segoe UI', Arial, sans-serif;
    font-size: 13px;
    color: #1a1a2e;
    padding: 24px 12px;
  }
  .wrapper {
    max-width: 860px;
    margin: 0 auto;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0,0,0,0.12);
  }
  .header {
    background: #1a4a7a;
    padding: 24px 28px;
    color: #fff;
  }
  .header-badge {
    display: inline-block;
    background: #27ae60;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 3px 10px;
    border-radius: 20px;
    margin-bottom: 10px;
  }
  .header h1 { font-size: 20px; font-weight: 700; margin-bottom: 4px; }
  .header p  { font-size: 12px; opacity: 0.75; margin-bottom: 14px; }
  .header-meta { width: 100%; border-collapse: collapse; }
  .header-meta td { padding-right: 32px; vertical-align: top; white-space: nowrap; }
  .header-meta span   { display: block; font-size: 11px; opacity: 0.75; }
  .header-meta strong { display: block; font-size: 13px; }

  .summary-bar {
    background: #f0f5fa;
    border-bottom: 1px solid #d0dce8;
    padding: 12px 28px;
    font-size: 12.5px;
    color: #333;
  }
  .summary-bar b { color: #0f2d52; }

  .action-bar {
    background: #fff8e1;
    border-left: 4px solid #f39c12;
    margin: 16px 28px;
    padding: 10px 14px;
    border-radius: 0 6px 6px 0;
    font-size: 12.5px;
    color: #7d5a00;
  }
  .action-bar strong { display: block; margin-bottom: 3px; color: #5a3e00; font-size: 13px; }

  .section { padding: 0 28px 20px; }
  .section-title {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #1a4a7a;
    border-bottom: 2px solid #1a4a7a;
    padding-bottom: 5px;
    margin-bottom: 12px;
    margin-top: 20px;
  }

  table.kv { width: 100%; border-collapse: collapse; font-size: 13px; }
  table.kv tr td { padding: 7px 10px; border: 1px solid #dce6f0; vertical-align: top; }
  table.kv tr td:first-child {
    width: 220px;
    background: #f0f5fa;
    font-weight: 600;
    color: #0f2d52;
  }
  table.kv tr:nth-child(even) td:last-child { background: #fafcfe; }

  table.data { width: 100%; border-collapse: collapse; font-size: 12px; }
  table.data th {
    background: #1a4a7a;
    color: #fff;
    padding: 7px 10px;
    text-align: center;
    border: 1px solid #0f2d52;
    font-size: 11px;
    font-weight: 600;
  }
  table.data th.left { text-align: left; }
  table.data td {
    padding: 7px 10px;
    border: 1px solid #dce6f0;
    text-align: center;
    background: #fff;
  }
  table.data td.changed {
  background: #fff3cd !important;
  border: 1px solid #f0c419;
  font-weight: 700;
  color: #7a5c00;
}
tr.new-row td {
  background: #e8f8ee !important;
}
.tag-new {
  display: inline-block;
  background: #27ae60;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 10px;
  vertical-align: middle;
  margin-left: 4px;
}
  table.data td.left { text-align: left; }
  table.data tr:nth-child(even) td { background: #f5f9fc; }

  /* highlight H&F rates */
  .rate-highlight {
    background: #e8f4fd;
    border: 1px solid #b3d7f0;
    border-radius: 6px;
    padding: 12px 16px;
    margin-bottom: 12px;
    display: inline-block;
    min-width: 160px;
    text-align: center;
  }
  .rate-highlight .rate-label { font-size: 11px; color: #666; margin-bottom: 3px; }
  .rate-highlight .rate-value { font-size: 22px; font-weight: 700; color: #0f2d52; }
  .rate-highlight .rate-uom   { font-size: 11px; color: #888; }

  .tag-yes {
    display: inline-block;
    background: #e8f8ee; color: #1a7a3e;
    border: 1px solid #a8ddb8;
    border-radius: 12px; padding: 2px 9px;
    font-size: 11px; font-weight: 700;
  }
  .tag-no {
    display: inline-block;
    background: #fdecea; color: #b00000;
    border: 1px solid #f0b0aa;
    border-radius: 12px; padding: 2px 9px;
    font-size: 11px; font-weight: 700;
  }

  .divider { height: 1px; background: #e0e8f0; margin: 0 28px; }

  .footer-cta {
    background: #f0f5fa;
    border-top: 1px solid #d0dce8;
    padding: 20px 28px;
    text-align: center;
  }
  .footer-cta p { font-size: 12px; color: #666; margin-bottom: 12px; }

  .footer {
    background: #0f2d52;
    color: rgba(255,255,255,0.6);
    text-align: center;
    padding: 12px 28px;
    font-size: 11px;
  }
</style>
</head>
<body>
<div class="wrapper">

  <!-- HEADER -->
  <div class="header">
    <div class="header-badge">${isAddendum ? 'Contract Addendum' : 'New Contract Created'}</div>
    <h1>${contractUniqueID} – ${contractTitle}</h1>
    <p>${isAddendum ? 'Updated' : 'Created'} ${createdAt}</p>
    <table class="header-meta">
      <tr>
        <td><span>Contract ID</span><strong>${contractUniqueID}</strong></td>
        <td><span>Site Ref</span><strong>${siteAssessmentRef}</strong></td>
        <td><span>Felling Licence</span><strong>${fellingLicenceNo}</strong></td>
        <td><span>Pricing Version</span><strong>${pricingVersion}</strong></td>
      </tr>
    </table>
  </div>

  <!-- SUMMARY BAR -->
  <div class="summary-bar">
    <b>Supplier:</b> ${supplierName} &nbsp;·&nbsp;
    <b>Landowner:</b> ${landownerName} &nbsp;·&nbsp;
    <b>County:</b> ${county} &nbsp;·&nbsp;
    <b>Area:</b> ${totalArea} ha &nbsp;·&nbsp;
    <b>Harvested by:</b> ${harvestedBy}
  </div>

  <!-- ACTION -->
  <div class="action-bar">
    <strong>⚠ Action Required</strong>
    ${
      isAddendum
        ? `Please update this contract on <b>Sage</b> and confirm the revised rates on <b>Logwatch</b>.`
        : `Please create this contract on <b>Sage</b> and confirm on <b>Logwatch</b>.`
    }
  </div>

  <!-- CONTRACT DETAILS -->
  <div class="section">
    <div class="section-title">Contract Details</div>
    <table class="kv">
      <tr><td>Contract ID</td><td>${contractUniqueID}</td></tr>
      <tr><td>Label</td><td>${labelOfContract}</td></tr>
      <tr><td>Contract Type</td><td>${contractType}</td></tr>
      <tr><td>Purchase Type</td><td>${purchaseType}</td></tr>
      <tr><td>Felling Licence No</td><td>${fellingLicenceNo}</td></tr>
      <tr><td>Pricing Version</td><td>${pricingVersion}</td></tr>
      <tr><td>Start Date</td><td>${startDate}</td></tr>
      <tr><td>End Date</td><td>${finishDate}</td></tr>
      <tr><td>VAT Rate</td><td>${vatRate}%</td></tr>
    </table>
  </div>

  <div class="divider"></div>

  <!-- PRODUCT PRICING TABLE — per destination + haulage -->
  <div class="section">
    <div class="section-title">Product Pricing &amp; Haulage Rates</div>
    <table class="data">
      <thead>
        <tr>
          <th class="left">Product</th>
          <th>Destination</th>
          <th>Haulage Rate</th>
          <th>Harvesting Rate</th>
          <th>Extraction Rate</th>
          <th>Purchase Price</th>
        </tr>
      </thead>
      <tbody>
        ${pricingRows}
      </tbody>
    </table>
  </div>

  <div class="divider"></div>

  <!-- NOTIFICATION CONTACTS — from modal input, not hardcoded -->
  <div class="section">
    <div class="section-title">Notification Contacts</div>
    <table class="data">
      <thead>
        <tr>
          <th class="left">Contact</th>
          <th class="left">Email</th>
          <th class="left">Phone</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="left"><strong>Grower / Owner</strong></td>
          <td class="left">
            ${
              notificationContact.email
                ? `<a href="mailto:${notificationContact.email}">${notificationContact.email}</a>`
                : '—'
            }
          </td>
          <td class="left">${notificationContact.phone || '—'}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="divider"></div>

  <!-- ACCOUNT DETAILS -->
  <div class="section">
    <div class="section-title">Account Details (for payments)</div>
    <table class="kv">
      <tr><td>Account Holder</td><td>${accountDetails.accountHolder || '—'}</td></tr>
      <tr><td>Bank Name</td><td>${accountDetails.bankName || '—'}</td></tr>
      <tr><td>IBAN</td><td>${accountDetails.iban || '—'}</td></tr>
      <tr><td>BIC</td><td>${accountDetails.bic || '—'}</td></tr>
    </table>
  </div>

  ${certSection}

  <div class="divider"></div>

  <!-- DOCUMENTS -->
  <div class="section">
    <div class="section-title">Uploaded Documents</div>
    <table class="kv">
      ${(uploadedDocuments ?? [])
        .map(
          doc => `
        <tr>
          <td style="padding: 4px 0;">
            <a href="${doc.url}" 
              style="color: #1a73e8; text-decoration: none; font-size: 13px;">
              ${doc.docType}
            </a>
          </td>
        </tr>
      `,
        )
        .join('')}
    </table>
  </div>

  <!-- FOOTER CTA -->
  <div class="footer-cta">
    <p>Review the full contract details, rates, and documents in the system.</p>
    <a href="${contractUrl}"
      style="display:inline-block;background:#1a4a7a;color:#fff!important;
             text-decoration:none;padding:13px 36px;border-radius:6px;
             font-size:14px;font-weight:700;letter-spacing:0.3px;">
      View Full Contract
    </a>
  </div>

  <!-- FOOTER -->
  <div class="footer">
    ${contractUniqueID} &nbsp;·&nbsp; ${contractTitle} &nbsp;·&nbsp; Auto-generated notification
  </div>

</div>
</body>
</html>`;
};
